/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('CheckoutOrderTypeController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};

        var controlName = 'OrderType';
        $scope.registerControl(controlName, $element.get(0));

        var savedOrderTypeId = undefined; 
        $scope.Control.SelectedOrderTypeId = undefined;

        var setSelectedOrderType = function (orderTypeId) {
            var deferred = $q.defer();

            var orderType = _.first(_.filter($scope.Model.Data.OrderTypes, function (x) { return x.Id === orderTypeId; }));
            
            if (!orderType) {
            	orderType = _.first($scope.Model.Data.OrderTypes, function (x) { return x.Id });
            }
            $scope.Control.SelectedOrderTypeId = orderType.Id;
            savedOrderTypeId = orderType;

            ControlService.invokeCheckout($scope, $element, 'SetOrderType', orderType).then(function (setResponse) {
                $scope.setControlValue(controlName, orderType);
                
                savedOrderTypeId = orderType.Id;

                if ($scope['PaymentMethod'] && $scope['PaymentMethod'].Wrapper && typeof ($scope['PaymentMethod'].Wrapper.reload) == 'function') {
                    $scope['PaymentMethod'].Wrapper.reload().then(function (bmresponse) {
                        deferred.resolve(true);
                        $scope.Control.Loading = false;
                    }, function (bmerror) {
                        deferred.reject(bmerror);
                        $scope.Control.Loading = false;
                    });
                } else {
                    deferred.resolve();
                    $scope.Control.Loading = false;
                }
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });

            return deferred.promise;
        };

        $scope.Control.setSelectedOrderType = function (orderTypeId) {

            if (savedOrderTypeId == orderTypeId)
                return;

            setSelectedOrderType(orderTypeId).then(function (parameters) {
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
            });
        };

        $scope.Control.setifGiftSelected = function () {
        	setifGiftSelected();
        };

        var setifGiftSelected = function () {

        	if ($('#giftWrap').is(':checked')) {
        		$scope.BillingAsShipping = false;
        		$scope.scrollToBillingAddress();
        	}

        	if (!$('#giftWrap').is(':checked')) {
        		$scope.BillingAsShipping = true;
        	}

        	if ($('#giftWrap').is(':checked')) {
        		setSelectedOrderType(2);
        	} else if (!$('#giftWrap').is(':checked') && $scope.BillingAsShipping == true) {
        		setSelectedOrderType(1);
        	}

        	return;
        };
        
        ControlService.getCheckoutData("GetOrderTypeData", $scope, $element).then(function (response) {

            $scope.Control.SelectedOrderTypeId = undefined;
            if ($scope['Order'] && $scope['Order'].Current) {
                if ($scope['Order'].Current.Store.Id !== 0) {
                    $scope.Control.SelectedOrderTypeId = savedOrderTypeId = $scope['Order'].Current.OrderType.Id;
                }
            }

            $scope.Model = {};
            angular.extend($scope.Model, response);
            $scope.Control.Loading = false;
        }, function (error) {
            $scope.Control.Loading = false;
            throw error;
        });
    });
})();